import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=567bb6b9&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567bb6b9')) {
      api.createRecord('567bb6b9', component.options)
    } else {
      api.reload('567bb6b9', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=567bb6b9&", function () {
      api.rerender('567bb6b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IJ4vR5LCpPvF/JS/comp/openstreetmap.vue"
export default component.exports